import useTypedContext from "hooks/useTypedContext";
import { BillingTierFeature } from "types/generated";
import useTierFeature from "views/Account/hooks/useTierFeature";
import { SpacesContext } from "views/Account/SpacesProvider";

const useCanDeleteIntegrations = (billingTier: BillingTierFeature) => {
  const { hasEntityCreateAccess } = useTypedContext(SpacesContext);
  const isFeatureActive = useTierFeature(billingTier);

  return isFeatureActive && hasEntityCreateAccess;
};

export default useCanDeleteIntegrations;
